'use client';

import { __resetStyles, __styles, mergeClasses } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
import { drawerSeparatorStyles } from '../../shared/drawerSeparatorStyles';
export const drawerFooterClassNames = {
  root: 'fui-DrawerFooter'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__resetStyles("r1snvl2j", null, [".r1snvl2j{width:100%;max-width:100%;padding:var(--spacingVerticalL) var(--spacingHorizontalXXL) var(--spacingVerticalXXL);display:flex;justify-content:flex-start;align-items:center;column-gap:var(--spacingHorizontalS);box-sizing:border-box;position:relative;z-index:2;}"]);
const useDrawerFooterStyles = /*#__PURE__*/__styles({
  separator: {
    Baz25je: "f16b62f1",
    Brfgrao: "f1j7ml58",
    mdwyqc: ["f1f351id", "f1fzr1x6"],
    Fbdkly: ["f1fzr1x6", "f1f351id"],
    vz82u: "f1dhznln",
    cmx5o7: "f1p5zmk",
    h7gv66: "f1ljjo4k",
    B8bqphf: "ffd2d9j",
    wjn42g: "ffdt3s5",
    Ftih45: "f1wl9k8s",
    Bciustq: "ffi060y"
  },
  separatorVisible: {
    vz82u: "f1b3qyzu"
  }
}, {
  d: [".f16b62f1::before{height:1px;}", ".f1j7ml58::before{position:absolute;}", ".f1f351id::before{right:0;}", ".f1fzr1x6::before{left:0;}", ".f1dhznln::before{opacity:0;}", ".f1p5zmk::before{background-color:var(--colorNeutralStroke1);}", ".f1ljjo4k::before{transition-duration:var(--durationNormal);}", ".ffd2d9j::before{transition-property:opacity;}", ".ffdt3s5::before{transition-timing-function:var(--curveEasyEase);}", ".f1wl9k8s::before{content:\"\";}", ".ffi060y::before{top:0;}", ".f1b3qyzu::before{opacity:1;}"]
});
/**
 * Apply styling to the DrawerFooter slots based on the state
 */
export const useDrawerFooterStyles_unstable = state => {
  const styles = useStyles();
  const rootStyles = useDrawerFooterStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(drawerFooterClassNames.root, styles, state.scrollState !== 'none' && rootStyles.separator, ['middle', 'top'].includes(state.scrollState) && rootStyles.separatorVisible, state.root.className);
  return state;
};